import React from 'react'
import { Box, Typography } from '@mui/material';

const FacultyHistoryTools = (props) => {
  return (
    <Box
    sx={{
      mb: '10px',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}>
      <Typography sx={{ m: 1 }} variant="h5">
        Faculty
      </Typography>
    </Box>
  )
}

export default FacultyHistoryTools
